import { httpsCallable } from 'firebase/functions';
import { functions } from '@/services/firebase';

export const createAccountLink = async (refreshUrl: string, returnUrl: string): Promise<string> => {
  const callable = httpsCallable(functions, 'createAccountLink');
  const res: any = await callable({ refreshUrl, returnUrl });
  return res.data.url as string;
};

export const createCheckoutSession = async (params: any): Promise<string> => {
  const callable = httpsCallable(functions, 'createCheckoutSession');
  const res: any = await callable(params);
  return res.data.url as string;
};

export const createAppointmentCheckoutSession = async (params: {
  appointmentId: string;
  lawyerUid: string;
}): Promise<string> => {
  const callable = httpsCallable(functions, 'createAppointmentCheckoutSession');
  const res: any = await callable(params);
  return res.data.url as string;
};

export const resendAppointmentPaymentLink = async (params: {
  appointmentId: string;
  lawyerUid: string;
}): Promise<void> => {
  const callable = httpsCallable(functions, 'resendAppointmentPaymentLink');
  await callable(params);
};

export const refreshStripeAccount = async (): Promise<any> => {
  const callable = httpsCallable(functions, 'refreshStripeAccount');
  const res: any = await callable();
  return res.data;
}; 
